<!-- display a checkbox in user management page for "OnLegalHold" column -->
<mat-checkbox  [(ngModel)]="params.value" aria-label="OnLegalHold"
  (change)="this.refresh(this.params)" [disabled]="this.checkVisible"
  [ngClass]="checked ? 'checked-color-after checked-color-before' :'before-checked after-checked'" style="margin-top: 4px"></mat-checkbox>
